export  { storage } from "./storage";

type EventDateFields = {
  date?: string;
  endDate?: string;
  status?: string;
};

type PricingType = {
  type: string;
};

export function getEventEndDate(event?: EventDateFields) {
  return parseEventDate(event?.endDate || event?.date);
}

export function isEventSalesClosed(event?: EventDateFields, now = new Date()) {
  const endDate = getEventEndDate(event);

  if (!endDate) {
    return event?.status ? event.status.toLowerCase() !== "active" : false;
  }

  return endDate.getTime() < now.getTime();
}

export function getEventStatusLabel(event?: EventDateFields) {
  if (isEventSalesClosed(event)) {
    return "Done";
  }

  return event?.status?.toLowerCase() === "active" ? "Active" : "Inactive";
}

function parseEventDate(value?: string) {
  if (!value) return undefined;

  const trimmed = value.trim();
  const dateOnlyMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);

  if (dateOnlyMatch) {
    const [, year, month, day] = dateOnlyMatch;
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      23,
      59,
      59,
      999
    );
  }

  const parsed = new Date(trimmed);

  return Number.isNaN(parsed.getTime()) ? undefined : parsed;
}

export function sortEventPricings<T extends PricingType>(pricings: T[]) {
  const preferredOrder = ["SILVER", "PREMIERE", "GOLD", "PLATINUM"];

  return [...pricings].sort((a, b) => {
    const aIndex = preferredOrder.indexOf(a.type.toUpperCase());
    const bIndex = preferredOrder.indexOf(b.type.toUpperCase());

    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;

    return a.type.localeCompare(b.type);
  });
}
